import { renderToString } from "katex";
import "katex/dist/katex.min.css";

// These are author-controlled LaTeX expressions, never user-provided HTML.
const formulas = {
  male: String.raw`\begin{gathered}
    \text{Yağ oranı (\%)} = \\[0.5em]
    \frac{495}{\begin{gathered}
      1.0324 - 0.19077\,\log_{10}(\text{karın} - \text{boyun}) \\
      {}+ 0.15456\,\log_{10}(\text{boy})
    \end{gathered}} - 450
  \end{gathered}`,
  female: String.raw`\begin{gathered}
    \text{Yağ oranı (\%)} = \\[0.5em]
    \frac{495}{\begin{gathered}
      1.29579 \\
      {}- 0.35004\,\log_{10}(\text{bel} + \text{kalça} - \text{boyun}) \\
      {}+ 0.22100\,\log_{10}(\text{boy})
    \end{gathered}} - 450
  \end{gathered}`,
  bmi: String.raw`\begin{gathered}
    \mathrm{BMI} = \frac{\text{kilo (kg)}}{\bigl(\text{boy (m)}\bigr)^2} \\[0.8em]
    \begin{aligned}
      \text{Yağ oranı (\%)} &= 1.20\,\mathrm{BMI} + 0.23\,\text{yaş} \\
      &\quad - 10.8\,S - 5.4
    \end{aligned} \\[0.5em]
    S = \begin{cases}1 & \text{erkek} \\ 0 & \text{kadın}\end{cases}
  \end{gathered}`,
};

const rendered = Object.fromEntries(
  Object.entries(formulas).map(([name, expression]) => [
    name,
    renderToString(expression, {
      displayMode: true,
      output: "htmlAndMathml",
      throwOnError: true,
      trust: false,
      strict: "error",
    }),
  ]),
);

export function BodyFatFormula({ name }: { name: keyof typeof formulas }) {
  return (
    <div
      className="not-prose my-6 overflow-x-auto bg-transparent py-2 text-foreground text-sm sm:text-base [&_.katex-display]:min-w-max [&_.katex]:text-[1em]"
      dangerouslySetInnerHTML={{ __html: rendered[name] }}
    />
  );
}
